import type { IconSize } from '@cheqroom/components/Icon';
import { Icon as SharedIcon } from '@cheqroom/components/Icon';
import type { SvgProps } from '@cheqroom/icons';
import type { FC, LazyExoticComponent } from 'react';

// `IconSource`/`IconSourceComponent` are redeclared here — using this package's own React 18 `FC` —
// rather than re-exported from `@cheqroom/components/Icon` directly: that package resolves its own
// (React 19) @types/react, whose `ReactNode` also permits `bigint`/`Promise<ReactNode>` — not assignable
// to this package's React 18 `ReactNode`. A consumer typing a local icon component as `IconSource` and
// passing it to this package's own `createElement`/JSX would fail with "not assignable to
// FunctionComponent<...>" the same way `Avatar` failed as a JSX component (see Avatar.tsx). `SvgProps`
// itself is safe to import directly — it's a plain data interface, no React-version-specific generics.
export type IconSourceComponent = FC<SvgProps>;
export type IconSource = IconSourceComponent | LazyExoticComponent<IconSourceComponent>;

export interface Props extends Omit<SvgProps, 'color' | 'focusable' | 'style'> {
	source: IconSource;
	/** @default 'medium' */
	size?: IconSize;
	color?: string;
}

export const Icon = SharedIcon as unknown as FC<Props>;
export type { Props as IconProps, IconSize as Size };
